import defaultGameChildComponents from '@/components/game/implementations/_default/_components';
import WordSeachCallboardComponent from './callboard';
import WordSearchCallValueComponent from './call-value';
import ThemeDisplayComponent from './theme-display';

const gameChildComponents = Object.assign({}, defaultGameChildComponents,
  {
    wordsearchCallboard: WordSeachCallboardComponent,
    wordsearchCallValue: WordSearchCallValueComponent,
    themeDisplay: ThemeDisplayComponent,
  });
export default gameChildComponents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/wordsearch/_components/index.ts